(function ($) {
	'use strict';

	$(function () {

		const $trigger = $('.js-site-offcanvas-trigger');
		const $body = $('.js-site-offcanvas');
		const $close = $('.js-site-offcanvas-close');
		const activeClass = 'site-offcanvas--is-active';
		const overflowClass = 'u-overflow-hidden';

		$trigger.on('click', function () {
			$body.addClass(activeClass);
			$('body').addClass(overflowClass);
		});

		$close.on('click', function () {
			$body.removeClass(activeClass);
			$('body').removeClass(overflowClass);
		});
	});
})(jQuery);
